import type { JSX } from 'preact';

type ShortcutRow = { action: string; keys: string };
type ShortcutGroup = { title: string; rows: readonly ShortcutRow[] };

const SHORTCUT_GROUPS: readonly ShortcutGroup[] = [
  {
    title: 'Tools',
    rows: [
      { action: 'Select', keys: 'V / 1' },
      { action: 'Hand', keys: 'H' },
      { action: 'Scale', keys: 'S' },
      { action: 'Rotate', keys: 'Q' },
      { action: 'Island', keys: 'I / 2' },
      { action: 'Rock', keys: 'R / 3' },
      { action: 'Terraces', keys: 'L' },
      { action: 'Shallow water', keys: 'W / 5' },
      { action: 'Checkpoint', keys: 'C / 6' },
      { action: 'Start area', keys: 'T / 7' },
      { action: 'Park area', keys: 'K' },
      { action: 'Route', keys: 'O' },
      { action: 'Place prop', keys: 'P' },
      { action: 'Erase prop / route', keys: 'X' },
    ],
  },
  {
    title: 'Camera',
    rows: [
      { action: 'Marquee', keys: 'Drag with Select' },
      { action: 'Add to box', keys: 'Shift-drag' },
      { action: 'Pan', keys: 'Hand / Space / middle-button / right-drag' },
      { action: 'Zoom', keys: 'Wheel' },
    ],
  },
  {
    title: 'Edit',
    rows: [
      { action: 'Close shape / finish route', keys: 'Enter' },
      { action: 'Cancel', keys: 'Esc' },
      { action: 'Delete', keys: 'Del / Backspace' },
      { action: 'Add or remove', keys: 'Shift / Ctrl-click' },
      { action: 'Move selection', keys: 'Drag' },
      { action: 'Nudge', keys: 'Arrows' },
      { action: 'Nudge ×10', keys: 'Shift+Arrows' },
      { action: 'Select all', keys: 'Ctrl+A' },
      { action: 'Duplicate', keys: 'Ctrl+D' },
      { action: 'Copy / cut / paste', keys: 'Ctrl+C / X / V' },
      { action: 'Snap to grid', keys: 'G' },
      { action: 'Elevation', keys: 'E' },
      { action: 'Show boat', keys: 'Hold B, wheel turns' },
      { action: 'Scale', keys: 'Drag a cyan corner' },
      { action: 'Rotate', keys: 'Drag a yellow corner' },
    ],
  },
  {
    title: 'File',
    rows: [
      { action: 'Undo', keys: 'Ctrl+Z' },
      { action: 'Redo', keys: 'Ctrl+Shift+Z / Ctrl+Y' },
      { action: 'Save', keys: 'Ctrl+S' },
      { action: 'Save as', keys: 'Ctrl+Shift+S' },
      { action: 'Leave test play', keys: 'Esc' },
    ],
  },
];

export function ShortcutList(): JSX.Element {
  return (
    <div id="editor-shortcut-hint" class="editor-shortcut-list">
      {SHORTCUT_GROUPS.map((group) => (
        <section key={group.title} class="editor-shortcut-group">
          <h3 class="editor-shortcut-heading">{group.title}</h3>
          <dl class="editor-shortcut-rows">
            {group.rows.map((row) => (
              <div key={`${group.title}-${row.action}-${row.keys}`} class="editor-shortcut-row">
                <dt>{row.action}</dt>
                <dd>{row.keys}</dd>
              </div>
            ))}
          </dl>
        </section>
      ))}
    </div>
  );
}
